import VueI18n from 'vue-i18n';
import zh from '../i18n/zh-CN';
import en from '../i18n/en-US.json';
import el_en from 'element-ui/lib/locale/lang/en'
import el_zh from 'element-ui/lib/locale/lang/zh-CN'
(function (global) {
    global.config = {
        env: "prod", //dev-本地开发，test-线上测试,prod-生产环境
        successCode: "course_0000_0000",
        liveSuccessCode: "livemanage.0000.0000",
        eduSuccessCode: 200,
        unauthorizedCode: "course_0000_0002",
        successMessage: "OK"
    };

    global._third_platform = [
        { key: 'chinamooc', label: '中国大学MOOC', value: '6' },
        { key: 'pmphmooc', label: '人卫慕课', value: '8' },
        { key: 'zhihuishu', label: '智慧树', value: '7' },
        { key: 'superstar', label: '超星', value: '5' },
        { key: 'iclassroom', label: '爱课堂', value: '3' },
        { key: 'rain_classroom', label: '雨课堂', value: '4' },
        { key: 'umooc', label: '优慕课', value: '9' },
        { key: 'xuetang_online', label: '学堂在线', value: '11' },
        { key: 'xueyin_online', label: '学银在线', value: '12' },
    ];
    if (!Array.prototype.find) {
        Array.prototype.find = function (callback) {
            return callback && (this.filter(callback) || [])[0];
        };
    }
    if (!Array.prototype.filter) {
        Array.prototype.filter = function (fun /*, thisArg */) {
            "use strict";
            if (this === void 0 || this === null)
                throw new TypeError();
            var t = Object(this);
            var len = t.length >>> 0;
            if (typeof fun !== "function")
                throw new TypeError();
            var res = [];
            var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
            for (var i = 0; i < len; i++) {
                if (i in t) {
                    var val = t[i];
                    if (fun.call(thisArg, val, i, t))
                        res.push(val);
                }
            }
            return res;
        };
    }
    //这个是判断 没有includes 方法的
    if (!Array.prototype.includes) {
        Object.defineProperty(Array.prototype, 'includes', {
            value: function (valueToFind, fromIndex) {

                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }

                // 1. Let O be ? ToObject(this value).
                var o = Object(this);

                // 2. Let len be ? ToLength(? Get(O, "length")).
                var len = o.length >>> 0;

                // 3. If len is 0, return false.
                if (len === 0) {
                    return false;
                }

                // 4. Let n be ? ToInteger(fromIndex).
                //    (If fromIndex is undefined, this step produces the value 0.)
                var n = fromIndex | 0;

                // 5. If n ≥ 0, then
                //  a. Let k be n.
                // 6. Else n < 0,
                //  a. Let k be len + n.
                //  b. If k < 0, let k be 0.
                var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

                function sameValueZero(x, y) {
                    return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
                }

                // 7. Repeat, while k < len
                while (k < len) {
                    // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                    // b. If SameValueZero(valueToFind, elementK) is true, return true.
                    if (sameValueZero(o[k], valueToFind)) {
                        return true;
                    }
                    // c. Increase k by 1. 
                    k++;
                }

                // 8. Return false
                return false;
            }
        });
    }

    // 全局方法
    global.debounce = (func, delay = 0) => {
        if (typeof func !== 'function') {
            throw new TypeError('need a function');
        }
        let timer = null;
        return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, arguments);
                timer = null;
            }, delay);
        };
    }

    global.throttle = (func, delay = 0) => {
        let timeoutId;
        return function (...args) {
            if (!timeoutId) {
                func.apply(this, args);
                timeoutId = setTimeout(() => {
                    timeoutId = null;
                }, delay);
            }
        };
    }

    /**
     * 格式化时间戳 Y-m-d H:i:s
     * @param {String} format Y-m-d H:i:s
     * @param {Number} timestamp 时间戳
     * @return {String}
     */
    global.dateFormate = (timeStamp, format = 'y.m.d h:i') => {
        if ((typeof timeStamp === "number" && isNaN(timeStamp)) || !timeStamp) return ''
        let _date = new Date(timeStamp),
            y = _date.getFullYear(),
            m = _date.getMonth() + 1,
            d = _date.getDate(),
            h = _date.getHours(),
            i = _date.getMinutes(),
            s = _date.getSeconds();

        m = m < 10 ? '0' + m : m;
        d = d < 10 ? '0' + d : d;
        h = h < 10 ? '0' + h : h;
        i = i < 10 ? '0' + i : i;
        s = s < 10 ? '0' + s : s;

        return format.replace(/[ymdhis]/g, key => {
            return {
                y,
                m,
                d,
                h,
                i,
                s
            }[key];
        });
    }
    /**
     * 转换时间成 1day 1hour 48min格式
     * @param s 毫秒
     */
    global.formatDate2Time = (s) => {
        let days = Math.floor(s / (1000 * 60 * 60 * 24));
        let hours = Math.floor((s % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((s % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((s % (1000 * 60)) / 1000);
        return `${days ? days + 'day' : ''}${hours ? hours + 'hour' : ''}${minutes ? minutes + 'min' : ''}${seconds ? seconds + 's' : ''}`;
    }
    /**
     * 帧转时分秒
     * @param s 毫秒
     */
    global.durationTrans = (a) => {
        a = parseInt((a || 0) / 10000000)
        var b = ""
        var h = parseInt(a / 3600),
            m = parseInt(a % 3600 / 60),
            s = parseInt(a % 3600 % 60);
        h = h < 10 ? '0' + h : h
        m = m < 10 ? '0' + m : m
        s = s < 10 ? '0' + s : s
        b += h + ":" + m + ":" + s
        return b;
    }
    /**
     * 移动端底部菜单栏点击事件
     * @param link
     */
    global.handleCommand = (link) => {
        console.log('handleCommand', link)
        window.location.href = link;
    }
    /**
     * 递归遍历树形结构
     * @param tree
     */
    global.forTree = (tree) => {
        return tree.map((item) => {
            if (item.children.length == 0) {
                delete item.children
                return item
            } else {
                return {
                    ...item,
                    children: forTree(item.children)
                }
            }
        })
    }
    /**
     * 递归遍历构造树形结构
     * @param tree
     */
    global.toTree = (obj) => {
        if (Array.isArray(obj)) {
            //教学地点 最后一层是数组
            return obj.map(item => (
                {
                    label: item,
                    value: item,
                }
            ))
        } else if (typeof (obj) == 'object') {
            return Object.keys(obj).map((item) => {
                if (JSON.stringify(obj[item]) == '{}') {
                    return {
                        label: item,
                        value: item,
                    }
                } else {
                    return {
                        label: item,
                        value: item,
                        children: toTree(obj[item])
                    }
                }

            })
        } else {
            return [];
        }
    }
    /**
     * @description: 多种浏览器滚动事件监听封装
     * @param {*} DomObj 需要滚动的DOM元素对象
     * @param {*} fn  滚动时执行的方法
     * @return {*}
     */
    global.mouseWheelFn = (DomObj, fn) => {
        // 处理滚动回调事件以及阻止默认事件
        function fnWheel(ev) {
            let oEvent = ev || event
            // 默认 false 即不是Firefox， oEvent.detail > 0 为 Firefox
            let bDown = false
            bDown = oEvent.wheelDelta ? oEvent.wheelDelta < 0 : (oEvent.detail > 0)
            // 对 Firefox 滚动值取反并放大24倍
            let wheelDelta = oEvent.wheelDelta ? oEvent.wheelDelta : (-oEvent.detail * 24)
            // 处理调事件
            fn && fn({ ...oEvent, wheelDelta }, bDown)
            // 阻止默认事件
            // oEvent.preventDefault && oEvent.preventDefault()
            // return false
        }
        // 判断是否是Firefox浏览器
        if (window.navigator.userAgent.indexOf('Firefox') !== -1) {
            // 是，执行 addEventListener 监听 DOMMouseScroll 事件
            DomObj.addEventListener('DOMMouseScroll', fnWheel, false)
        } else {
            // 不是，可能是IE、Chrome, 需要对监听方法做兼容
            // 判断浏览器是否有 addEventListener 方法
            if (DomObj.addEventListener) {
                DomObj.addEventListener('mousewheel', fnWheel, false)
            } else {
                DomObj.attachEvent('on' + 'mousewheel', fnWheel)
            }
        }
    }
    /**
     * window挂载全局深度埋码方法
     * @param platform 平台（省平台为 aplus_queue，百度统计为 _hmt， 西工大统计为 _npuTracker）
     * @param params push值
     */
    global.depthStatistics = ({ platform, params }) => {
        return new Promise((resolve, reject) => {
            if (!platform || !window[platform]) return
            const statisticsFun = window[platform]
            let obj = params.arguments[2] || {}
            let toUuidArr = ['course_id', 'resource_id', 'video_id']
            toUuidArr.map(name => {
                if (obj && obj[name]) {
                    let strArr = obj[name].split('')
                    strArr.splice(8, 0, '-')
                    strArr.splice(13, 0, '-')
                    strArr.splice(18, 0, '-')
                    strArr.splice(23, 0, '-')
                    obj[name] = strArr.join('')
                    params.arguments[2] = obj
                }
            })

            if (platform == 'aplus_queue') {
                //设置DEBUG模式
                statisticsFun.push({
                    action: 'aplus.setMetaInfo',
                    arguments: ['DEBUG', false]
                })
                // console.log('【深度埋码】',params)
                statisticsFun.push(params)
                resolve()
            } else {
                reject()
            }
        })
    }
    global.liveAddressFormat = (addressObj, liveId) => {
        let liveAddress = Object.keys(addressObj || {}).map(key => {
            var obj = {
                _id: liveId,
                push_url: addressObj[key],
                stream_address: addressObj[key]
            }
            switch (key) {
                case 'guide_url_flv':
                    return {
                        is_mute: 'false',
                        stream_name: "导切画面",
                        voice_identify: addressObj['guide_voice_identify'],
                        pull_url: addressObj['guide_url'],
                        push_url: addressObj['guide_url'],
                        ...obj,
                    }
                    break;
                case 'ai_url_flv':
                    return {
                        is_mute: addressObj['ai_has_voice'] ? 'true' : 'false',
                        stream_name: "屏幕画面",
                        voice_identify: addressObj['ai_voice_identify'],
                        pull_url: addressObj['ai_url'],
                        push_url: addressObj['ai_url'],
                        ...obj,
                    }
                    break;
                case 'student_full_url_flv':
                    return {
                        is_mute: addressObj['student_full_has_voice'] ? 'true' : 'false',
                        stream_name: "学生远景",
                        voice_identify: addressObj['student_full_voice_identify'],
                        pull_url: addressObj['student_full_url'],
                        push_url: addressObj['student_full_url'],
                        ...obj,
                    }
                    break;
                case 'student_trace_url_flv':
                    return {
                        is_mute: addressObj['student_trace_has_voice'] ? 'true' : 'false',
                        stream_name: "学生近景",
                        voice_identify: addressObj['student_trace_voice_identify'],
                        pull_url: addressObj['student_trace_url'],
                        push_url: addressObj['student_trace_url'],
                        ...obj,
                    }
                    break;
                case 'student_singl_url_flv':
                    return {
                        is_mute: addressObj['student_singl_has_voice'] ? 'true' : 'false',
                        stream_name: "学生单目",
                        voice_identify: addressObj['student_singl_voice_identify'],
                        pull_url: addressObj['student_singl_url'],
                        push_url: addressObj['student_singl_url'],
                        ...obj,
                    }
                    break;
                case 'teacher_full_url_flv':
                    return {
                        is_mute: addressObj['teacher_full_has_voice'] ? 'true' : 'false',
                        stream_name: "教师远景",
                        voice_identify: addressObj['teacher_full_voice_identify'],
                        pull_url: addressObj['teacher_full_url'],
                        push_url: addressObj['teacher_full_url'],
                        ...obj,
                    }
                    break;
                case 'teacher_trace_url_flv':
                    return {
                        is_mute: addressObj['teacher_trace_has_voice'] ? 'true' : 'false',
                        stream_name: "教师近景",
                        voice_identify: addressObj['teacher_trace_voice_identify'],
                        pull_url: addressObj['teacher_trace_url'],
                        push_url: addressObj['teacher_trace_url'],
                        ...obj,
                    }
                    break;
                case 'teacher_singl_url_flv':
                    return {
                        is_mute: addressObj['teacher_singl_has_voice'] ? 'true' : 'false',
                        stream_name: "教师单目",
                        voice_identify: addressObj['teacher_singl_voice_identify'],
                        pull_url: addressObj['teacher_singl_url'],
                        push_url: addressObj['teacher_singl_url'],
                        ...obj,
                    }
                    break;
                default:
                    return {}
            }
        })
        liveAddress = liveAddress.filter(el => {
            return el.stream_address
        })
        return liveAddress
    }
    global.i18n = new VueI18n({
        // 默认语言
        locale: localStorage.getItem('lang') || 'zh',
        messages: {
            zh: {
                ...el_zh,
                ...zh
            },
            en: {
                ...el_en,
                ...en
            }
        },
        silentTranslationWarn: true // 关闭控制台输出
    })
    global.loadScript = (url) => {
        return new Promise((resolve, reject) => {
            var script = document.createElement("script");
            script.type = "text/javascript";

            if (script.readyState) {  // IE
                script.onreadystatechange = function () {
                    if (script.readyState == "loaded" || script.readyState == "complete") {
                        script.onreadystatechange = null;
                        resolve();
                    }
                };
            } else {  // 其他浏览器
                script.onload = function () {
                    resolve();
                };
            }

            script.src = url;
            document.getElementsByTagName("head")[0].appendChild(script);
        })
    }
    global.getRoleName = (code) => {
        const roleMap = {
            "r_teacher_assistant": "助教",
            "r_college_supervisor": "院督导",
            "r_supervisor": "督导员",
            "r_teaching_manager": "教研组长",
            "public_space_role": "共享空间角色",
            "r_second_manager": "二级管理员",
            "third_party_manufacturer": "第三方厂商",
            "r_group_manager": "群组管理员",
            "r_student": "学生",
            "r_offcampusteam": "校外团队",
            "r_teacher": "教师",
            "r_resource_manager": "资源管理员",
            "r_sys_manager": "系统管理员",
            "r_course_manager": "课程管理员",
            "zhiliao": "超级管理员"
        }
        return roleMap[code] || '其他';
    }
    global.courseTypes = {
        0: 'micro',
        1: 'mooc',
        2: 'spoc',
        3: 'training'
    }
    /**
     * 学年学期展示
     */
    global.transferSmester = (year, semester, showType) => {
        const semesterToCN = { 1: '秋', 2: '春', 3: '夏' }
        switch (showType) {
            case 1:
                return `${year}学年${semesterToCN[semester]}`
            case 2:
                return `${year}学年${semesterToCN[semester]}季`
            case 3:
                return `${year}-${semester}`
            default:
                return `${year}学年${semesterToCN[semester]}`
        }
    }

})(window);